/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/observe-assess/scene',['require','jquery','core/templates','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  //var _ = require('underscore');
  var templates = require('core/templates');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var Question = Marionette.ItemView.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    template: templates['screens/observe-assess/scene'],
    events: {
      'click .btn': 'btnPressed'
    },
    disabled: false,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      //console.log('Scene::initialize');
    },

    btnPressed: function(e)
    {
      if (this.disabled)
        return;

      var el = $(e.currentTarget);
      var action = this.model.get('action');

      if ((el.hasClass('action') && action) || (el.hasClass('none') && !action))
        this.triggerMethod('action:pressed', action, true);
      else
        this.triggerMethod('action:pressed', action, false);

      return false;
    },

    disable: function()
    {
      this.disabled = true;
    },

    enable: function()
    {
      this.disabled = false;
    }

  /*****************************************************************************************************************///}

  });

  return Question;

});

